// 개발 환경 전용 — UI 컨트롤(.ui-btn / .ui-tab / .ui-menu-item)에서
// 텍스트가 1줄 폭을 넘어 잘리거나, 컨테이너가 2줄 이상 발생하면 console.warn.

import { useEffect } from 'react';

export function useDevGuardOneLine(): void {
	useEffect(() => {
		const meta = import.meta as unknown as { env?: { DEV?: boolean } };
		if (!meta.env?.DEV) return;
		const check = (): void => {
			const els = document.querySelectorAll<HTMLElement>('.ui-btn, .ui-tab, .ui-menu-item');
			els.forEach((el) => {
				if (el.scrollWidth > el.clientWidth + 1) {
					console.warn('[1줄 위반]', el.textContent?.trim(), {
						scrollW: el.scrollWidth, clientW: el.clientWidth, el,
					});
				}
				const cs = getComputedStyle(el);
				const lh = parseFloat(cs.lineHeight);
				if (!Number.isNaN(lh) && lh > 0) {
					const pt = parseFloat(cs.paddingTop) || 0;
					const pb = parseFloat(cs.paddingBottom) || 0;
					const lines = Math.round((el.clientHeight - pt - pb) / lh);
					if (lines > 1) {
						console.warn('[2줄 발생]', el.textContent?.trim(), 'lines=', lines, el);
					}
				}
			});
		};
		const ro = new ResizeObserver(check);
		if (document.body) ro.observe(document.body);
		const onResize = () => check();
		window.addEventListener('resize', onResize);
		const t = window.setTimeout(check, 500);
		return () => {
			ro.disconnect();
			window.removeEventListener('resize', onResize);
			window.clearTimeout(t);
		};
	}, []);
}
